import React from "react";
import { Button } from "react-bootstrap";

export default (props) => {
  return (
    <Button
      className={`${props.background ? props.background : "bg-gradient-to-tr from-green-300 to-green-400 text-green-700"} hover:opacity-75 border text-lg   font-bold  px-5 py-3 flex justify-center items-center rounded-md text-gray-700`}
      disabled={props.disabled}
      onClick={props.onClick}
      block={props.blocked}
      size={props.size}
    >
      {props.label}
    </Button>
  );
};
